import { z } from 'zod';
import { ModelCodeSchema } from '@/types/model-code/model-code.type.ts';

export const ModelCodesSchema = z.array(ModelCodeSchema);
